export default 
{
	"progressbar-page-title": "Seite",
	"name-suffix": "Zusatz",
	"fileupload-desc-progress-message": "Upload Fortschritt {progress}",
	"required-if-greater-than-or-equal": "{property} ist erforderlich, wenn {compareSource} größer oder gleich {compareValue} ist.",
	"powered-by-cognito": "Angetrieben durch Cognito Forms.",
	"form-name-default": "Ohne Titel",
	"field-choice-defaults": "Erste Option|Zweite Option|Dritte Option",
	"additional-fee-default-label": "Zusätzliche Gebühren",
	"authenticated-save-and-resume-email-dialog": "Senden Sie einen Link per E-Mail und kehren Sie zu Ihrem Formular zurück, um Ihre Übermittlung abzuschließen.",
	"string-length-between": "{property} muss zwischen {min} und {max} Zeichen lang sein.",
	"update-button-text": "Aktualisieren",
	"address-zip-code-invalid": "Zip Code muss formatiert werden als #####-####.",
	"required-if-greater-than": "{property} ist erforderlich, wenn {compareSource} größer als {compareValue} ist.",
	"compare-before": "{property} muss vor {compareSource} liegen.",
	"compare-after": "{property} muss nach {compareSource} sein.",
	"unsupported-browser-message": "Achtung! Sie verwenden einen nicht unterstützten Browser. Zum Aktualisieren {a}hier klicken{/a}.",
	"shared-entry-email-subject": "Geteilter Link",
	"send-button-text": "Senden",
	"venmo-help-text": "Verbinde dich mit Venmo, um mit der Zahlung fortzufahren.",
	"field-repeatingsection-item-label": "Artikel",
	"save-and-resume-email-not-sent-message": "Es gab ein Problem.",
	"credit-card-cvv": "Kartenprüfnummer",
	"range-at-least": "{property} muss mindestens {min} sein.",
	"entry-notification-full-entry-detail-link": "Sehen Sie die kompletten Daten auf cognitoforms.com.",
	"element-label-website": "Webseite",
	"element-label-signature": "Unterschrift",
	"paypal-help-text": "Verbinde dich mit PayPal, um mit der Zahlung fortzufahren.",
	"card-on-file-agreement-validation": "Sie müssen zustimmen, Ihre Karte für zukünftige Transaktionen zu speichern.",
	"marketing-button-4": "Bauen Sie Ihre Eigene Kostenlos",
	"field-datepicker-now": "Jetzt",
	"save-and-resume-email-resume-button": "Jetzt fortfahren",
	"field-datepicker-next-month": "Nächster Monat",
	"quantity-remaining-text": "verbleibend",
	"payment-declined": "Zahlung abgelehnt",
	"required-if-before": "{property} ist erforderlich, wenn {compareValue} vor {compareSource} liegt.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} muss kleiner als {compareSource} sein.",
	"entry-admin-link": "Administrator Link",
	"required-many": "{0} sind erforderlich.",
	"save-and-resume-multiple-days-expiration-email-message": "Nutzen Sie den unten angegeben Link, um Ihr Formular aufzurufen und Ihre Eingaben innerhalb der nächsten {days} Tage abzuschliessen.",
	"string-length-at-least": "{property} muss mindestens {min} Zeichen lang sein.",
	"credit-card-number": "Kreditkartennummer",
	"range-on-or-before": "{property} muss am oder vor {max} sein.",
	"required-one": "{0} ist erforderlich.",
	"fileupload-max-file-count-exceeded-message": "Nur {maxFileCount} Dateien können hochgeladen werden.",
	"order-transaction-details-header": "Angaben zur Transaktion",
	"field-spinner-increase": "Erhöhen",
	"payment-processing-fees": "Bearbeitungsgebühren",
	"payment": "Bezahlung",
	"field-choice-other-fill-in": "Andere",
	"shared-entry-email-message": "Ein Eintrag mit Ihnen geteilt worden.",
	"shared-entry-workflow-link": "Sehen Sie sich das Formular an.",
	"required-if-exists": "{property} ist erforderlich, wenn {compareSource} angegeben ist.",
	"concurrent-conflict-toast-message": "Ihre Übermittlung ist fehlgeschlagen, da sich die Informationen in diesem Formular geändert haben. Bitte prüfen und erneut versuchen.",
	"secured-by-paypal": "Geschützt durch",
	"range-on-or-after": "{property} muss am oder nach dem {min} sein.",
	"payment-amount-due": "Rechnungsbetrag",
	"required-name-first-and-last": "Vorname und Nachname sind erforderlich.",
	"required": "{property} ist erforderlich.",
	"string-format-alphabetic": "{property} darf nur Buchstaben enthalten.",
	"quantity-limit": "{property} menge überschritten.",
	"field-spinner-decrease": "Verringern",
	"field-repeatingsection-add-link-text": "Hinzufügen",
	"fileupload-max-size-exceeded-message": "Nur Dateien kleiner als {maxSize} MB können hochgeladen werden.",
	"credit-card-expiration": "MM/JJ",
	"field-signature-notcaptured": "Nicht Erfasst",
	"field-ratingscale-satisfied-unsatisfied-label": "Zufrieden/Unzufrieden",
	"range-between": "{property} muss zwischen {min} und {max} liegen.",
	"field-ratingscale-agree-disagree-label": "Stimme zu/Stimme nicht zu",
	"back-button-text": "Zurück",
	"address-country": "Land",
	"order-not-found": "Keine Bestellinformationen gefunden.",
	"field-ratingscale-satisfied-unsatisfied-options": "Sehr unzufrieden|Unzufrieden|Neutral|Zufrieden|Sehr zufrieden",
	"entry-notification-entry-details-header": "Übermittelte Daten",
	"FALSE": "FALSCH",
	"compare-greater-than-or-equal": "{property} muss größer oder gleich {compareSource} sein.",
	"receipt-notification-order-details-desc-header": "Beschreibung",
	"order-method-label": "Methode",
	"order-total-label": "Gesamtbestellung",
	"invalid-shared-link": "Ungültiger Link",
	"fileupload-zero-byte-file-message": "Null-Byte-Dateien können nicht hochgeladen werden.",
	"range-at-most": "{property} darf höchstens {max} sein.",
	"format-integer": "####",
	"order-date-label": "Datum",
	"fileupload-dropzone-message": "oder ziehen Sie die Dateien in dieses Feld.",
	"shared-entry-view-link": "Den shared Eintrag anzeigen.",
	"format-currency": "#.###,## €",
	"string-length-at-most": "{property} darf höchstens {max} Zeichen lang sein.",
	"entry-confirmation-footer-tagline": "Erstellen Sie Ihre eigenen leistungsfähigen Zahlungsformulare mit",
	"submit-button-text": "Senden",
	"marketing-msg": "Leicht leistungsstarke Formulare zu erstellen.",
	"required-if-on-or-after": "{property} ist erforderlich wenn {compareSource} am oder nach dem {compareValue} ist.",
	"card-on-file-agreement": "Ich stimme zu, meine Karte für zukünftige Transaktionen zu speichern.",
	"signature-draw": "zeichnen",
	"address-zip-code": "Postleitzahl",
	"compare-on-or-after": "{property} muss am oder nach dem {compareSource} sein.",
	"required-if-less-than-or-equal": "{property} ist erforderlich, wenn {compareSource} kleiner oder gleich {compareValue} ist.",
	"field-datepicker-next-year": "Nächtes Jahr",
	"change-button": "ändern",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Karte",
	"order-billing-info-header": "Abrechungsinformation",
	"entry-email-view-details-text": "Sehen Sie den kompletten Eintrag auf cognitoforms.com.",
	"save-and-resume-one-day-expiration-email-message": "Nutzen Sie den unten angegeben Link, um Ihr Formular aufzurufen und Ihre Eingaben innerhalb der nächsten Tage abzuschliessen.",
	"credit-card-authentication-failed": "Die Authentifizierung der Karte ist fehlgeschlagen.",
	"compare-less-than-or-equal": "{property} muss kleiner oder gleich {compareSource} sein.",
	"receipt-notification-order-details-balance-due": "Fälliger Betrag",
	"save-and-resume-multiple-days-expiration-message": "Kopieren oder mailen Sie den unten angegeben Link, um Ihr Formular  aufzurufen und Ihre Eingaben innerhalb der nächsten {days} Tage abzuschliessen.",
	"processing-fee-calculating-message": "Berechnung",
	"receipt-notification-trx-details-method": "Methode",
	"field-choice-no-match": "Nichts gefunden.",
	"fileupload-invalid-file-type-message": "Nur {allowedTypes} Dateien können hochgeladen werden.",
	"receipt-notification-trx-details-date": "Datum",
	"credit-card-authorization": "Kartenautorisierung",
	"address-line1": "Adresszeile 1",
	"required-if-not-exists": "{property} ist erforderlich, wenn {compareSource} nicht angegeben ist.",
	"required-if-not-equal": "{property} ist erforderlich, wenn {compareSource} nicht gleich {compareValue} ist.",
	"marketing-button-2": "Bauen Sie Ihre Eigene Kostenlos",
	"receipt-notification-billing-info-header": "Abrechungsinformation",
	"required-if-after": "{property} ist erforderlich, wenn {compareValue} nach {compareSource} ist.",
	"element-label-name": "Name",
	"required-if-equal": "{property} ist erforderlich, wenn {compareSource} gleich {compareValue} ist.",
	"connected-to-paypal": "Verbunden mit PayPal.",
	"people-form-email-quantity-exceeded-message": "Die E-Mail-Adresse muss eindeutig sein.",
	"receipt-notification-order-details-subtotal": "Zwischensumme",
	"shared-entry-edit-link": "Den Eintrag bearbeiten.",
	"receipt-notification-trx-details-header": "Angaben zur Transaktion",
	"address-city": "Stadt",
	"receipt-notification-order-details-amount-paid": "Betrag bezahlt",
	"credit-card-invalid": "Die Karte ist ungültig.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Es wurde ein neues Formular übermittelt.",
	"this-and-that": "{0} und {1}",
	"field-ratingscale-good-poor-label": "Gut/Schlecht",
	"network-unavailable-message": "Netzwerk nicht verfügbar, versuchen Sie es später erneut.",
	"dialog-close": "Schließen",
	"string-format-alphanumeric": "{property} darf nur Buchstaben und Zahlen enthalten.",
	"credit-card": "Kreditkarte",
	"remove-item": "Entfernen {item}",
	"receipt-notification-order-details-price-header": "Preis",
	"fileupload-upload-inprogress-message": "Datei Upload gestartet.",
	"public-terms-of-service-link-text": "Nutzungsbedingungen",
	"save-and-resume-email-subject": "Ihre gespeicherten Daten",
	"field-repeatingsection-remove-link-text": "Entfernen",
	"field-ratingscale-na-label": "Nicht verfügbar",
	"add-item": "Hinzufügen {item}",
	"field-toggle-options": "Ja/Nein|Wahr/Falsch|Auf/Zu|Aktiv/Inaktiv|Gelesen/Ungelesen",
	"order-submit-timeout": "Auftragsbearbeitung dauert zu lange. Bitte versuchen Sie Ihre Bestellung später.",
	"listlength-at-most": "Bitte geben Sie nicht mehr als {max} {property} ein.",
	"shared-entry-email-view-message": "Verwenden Sie unten angebenen Link, um den freigegebenen Eintrag anzuzeigen.",
	"order-number-label": "Anzahl",
	"card-declined": "Karte abgelehnt",
	"fileupload-default-upload-button-text": "Upload",
	"name-prefix": "Titel",
	"address-line2": "Adresszeile 2",
	"element-label-email": "E-Mail",
	"field-ratingscale-good-poor-options": "Sehr schlecht|Schlecht|Durchschnittlich|Gut|Sehr gut",
	"next-button-text": "Weiter ",
	"question": "Frage",
	"address-postalcode": "PLZ",
	"format-with-description": "{property} muss im {description} Format eingegeben werden.",
	"field-datepicker-prev-month": "Letzter Monat",
	"name": "Name",
	"receipt-notification-order-details-total-footer": "Gesamt",
	"confirmation-message": "Vielen Dank. Ihre Daten wurden übermittelt.",
	"shared-entry-email-edit-message": "Verwenden Sie unten angebenen Link, um den freigegebenen Eintrag zu bearbeiten.",
	"field-default-label": "Ohne Titel",
	"required-value": "{property} muss {value} sein.",
	"name-middle": "Beiname",
	"fileupload-failed-upload-message": "{fileName} konnte nicht hochgeladen werden.",
	"shared-entry-email-button-label": "Den Eintrag anzeigen.",
	"field-datepicker-year": "",
	"element-label-phone": "Telefon",
	"TRUE": "WAHR",
	"listlength-between": "Bitte Wert zwischen {min} und {max} {property} angeben.",
	"marketing-button-1": "Probieren Sie Es Jetzt",
	"entry-submission-error-heading": "Fehler bei der Datenübermittlung",
	"order-not-found-message": "Keine Bestellinformationen gefunden.",
	"format-without-description": "{property} hat nicht das korrekte Format.",
	"name-last": "Nachname",
	"field-ratingscale-one-five-label": "Skala von 1 bis 5",
	"listlength-at-least": "Bitte geben Sie mindestens {min} {property} ein.",
	"united-states": "USA",
	"field-signature-captured": "Erfasst",
	"compare-on-or-before": "{property} muss am oder vor dem {compareSource} sein.",
	"order-balance-due-label": "Fälliger Betrag",
	"required-if-less-than": "{property} ist erforderlich, wenn {compareSource} kleiner als {compareValue} ist.",
	"credit-card-postalcode": "PLZ",
	"form-not-available-message": "Dieses Formular ist derzeit nicht verfügbar.",
	"element-label-address": "Adresse",
	"receipt-notification-trx-details-number": "Anzahl",
	"public-submission-warning": "Bitte übermitteln Sie keine Kennwörter über Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Nutzen Sie den unten angegeben Link, um Ihr Formular aufzurufen und Ihre Eingaben abzuschliessen.",
	"fileupload-excluded-file-type-message": "Dateien mit dieser Endung können nicht hochgeladen werden.",
	"payment-subtotal": "Zwischensumme",
	"collapse": "Reduzieren",
	"save-button-text": "Speichern",
	"field-datepicker-prev-year": "Letztes Jahr",
	"signature-type": "eingeben",
	"order-amount-minimum": "Der Rechnungsbetrag muß größer 1,00 € sein.",
	"string-format-numeric": "{property} darf nur Zahlen enthalten.",
	"entry-confirmation-entry-details-header": "Übermittelte Daten",
	"connected-to-venmo": "Verbunden mit Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Beleg",
	"clear": "Löschen",
	"today": "Heute",
	"required-name-last": "Nachname ist erforderlich.",
	"marketing-button-3": "Probieren Sie Es Jetzt",
	"expand": "Erweitern",
	"compare-greater-than": "{property} muss größer als {compareSource} sein.",
	"field-ratingscale-will-wont-label": "Wahrscheinlich/Wahrscheinlich nicht",
	"required-name-first": "Vorname ist erforderlich.",
	"save-and-resume-one-day-expiration-message": "Kopieren oder mailen Sie den unten angegeben Link, um ihr Formular  aufzurufen und Ihre Eingaben innerhalb der nächsten Tage abzuschliessen.",
	"required-asterisk": "erforderlich",
	"credit-card-required": "Kreditkarte ist erforderlich.",
	"address-state-province-region": "Staat / Provinz / Region",
	"save-and-resume-email-sent-message": "Die E-Mail wurde versendet.",
	"workflow-action": "Aktion",
	"field-ratingscale-will-wont-options": "Definitiv nicht|Wahrscheinlich nicht|Nicht sicher|Wahrscheinlich|Auf jeden Fall",
	"save-and-resume-email-label": "Bitte senden Sie mir einen Link: ",
	"field-ratingscale-agree-disagree-options": "Stimme überhaupt nicht zu|Stimme nicht zu|Neutral|Stimme zu|Stimme uneingeschränkt zu",
	"order-exception-order-already-paid": "Dieser Auftrag wurde bereits bezahlt.",
	"fileupload-download-text": "Herunterladen",
	"address-state": "Bundesland",
	"allowed-values": "{property} ist nicht in der Liste der zulässigen Werte.",
	"shared-entry-workflow-email-button-label": "Öffnen Sie das Formular",
	"compare-equal": "{property} muss mit {compareSource} übereinstimmen.",
	"field-datepicker-clear": "Leeren",
	"name-first": "Vorname",
	"save-and-resume-message": "Ihr Fortschritt wurde gespeichert.",
	"save-and-resume-no-expiration-message": "Kopieren oder mailen Sie den unten angegeben Link, um Ihr Formular  aufzurufen und Ihre Eingaben abzuschliessen.",
	"entry-notification-view-details-text": "Details anzeigen",
	"order-exception-default-message": "Die Transaktion kann nicht verarbeitet werden.",
	"public-report-abuse-link-text": "Missbrauch melden",
	"order-amount-paid": "Betrag bezahlt",
	"element-label-default": "Ohne Titel",
	"countries": "Afghanistan|Ägypten|Albanien|Algerien|Amerikanisch-Samoa|Andorra|Angola|Anguilla|Antarktis|Antigua und Barbuda|Äquatorial-Guinea|Argentinien|Armenien|Aruba|Aserbaidschan|Äthiopien|Australien|Bahamas|Bahrain|Bangladesch|Barbados|Belarus|Belgien|Belize|Benin|Bermuda|Bhutan|Bolivien|Bosnien und Herzegowina|Botswana|Brazilien|Brunei Darussalam|Bulgarien|Burkina Faso|Burundi|Cayman-Inseln|Chile|China|Cocos (Keeling) Islands|Cook-Inseln|Costa Rica|Côte d \u0027 Ivoire|Dänemark|Demokratische Republik Kongo (Kinshasa)|Deutschland|Dominica|Dominikanische Republik|Dschibuti|Ecuador|El Salvador|Eritrea|Estland|Falkland-Inseln|Färöer Inseln|Fidschi|Finnland|Frankreich|Französische Süd-und Antarktisgebiete|Französisch-Guayana|Französisch-Polynesien|Gabun|Gambia|Georgien|Ghana|Gibraltar|Grenada|Griechenland|Grönland|Großbritannien|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Heiliger Stuhl|Honduras|Hong Kong|Indien|Indonesien|Insel Man|Irak|Iran (Islamische Republik)|Irland|Island|Israel|Italien|Jamaika|Japan|Jemen|Jordanien|Jungferninseln (Britisch)|Jungferninseln (US)|Kambodscha|Kamerun|Kanada|Kap Verde|Kasachstan|Katar|Kenia|Kirgistan|Kiribati|Kolumbien|Komoren|Kongo, Republik of(Brazzaville)|Korea, demokratische \u0027 s Rep (Nordkorea)|Korea, Republik (Südkorea)|Kosovo|Kroatien|Kuba|Kuwait|La Réunion|Lao, Menschen \u0027 s Demokratische Republik|Lesotho|Lettland|Libanon|Liberia|Libyen|Liechtenstein|Litauen|Luxemburg|Macau|Madagaskar|Malawi|Malaysien|Malediven|Mali|Malta|Marokko|Marshall-Inseln|Martinique|Mauretanien|Mauritius|Mayotte|Nordmazedonien, Republik|Mexiko|Mikronesien, Föderierten Staaten von|Moldau, Republik|Monaco|Mongolei|Montenegro|Montserrat|Mosambik|Myanmar, Burma|Namibia|Nauru|Nepal|Neu-Kaledonien|Neuseeland|Nicaragua|Niederlande|Niederländische Antillen|Niger|Nigeria|Niue|Nord-Mariana Inseln|Norwegen|Oman|Österreich|Ost-Timor (Timor-Leste)|Pakistan|Palästinensischen Gebiete|Palau|Panama|Papua Neu Guinea|Paraguay|Peru|Philippinen|Pitcairn Island|Polen|Portugal|Puerto Rico|Ruanda|Rumänien|Russische Föderation|Saint Lucia|Salomonen|Sambia|Samoa|San Marino|São Tomé und Príncipe|Saudi-Arabien|Schweden|Schweiz|Senegal|Serbien|Seychellen|Sierra Leone|Singapur|Slowakei (Slowakische Republik)|Slowenien|Somalia|Spanien|Sri Lanka|St. Kitts und Nevis|St. Vincent und die Grenadinen|Südafrika|Sudan|Süd-Sudan|Suriname|Swasiland|Syrien, Arabische Republik Syrien|Tadschikistan|Taiwan (Republik China)|Tansania; offiziell der Vereinigten Republik Tansania|Thailand|Tibet|Timor-Leste (Osttimor)|Togo|Tokelau|Tonga|Trinidad und Tobago|Tschad|Tschechische Republik|Tunesien|Turkei|Turkmenistan|Turks And Caicos Islands|Tuvalu|Uganda|Ukraine|Ungarn|Uruguay|USA|Usbekistan|Vanuatu|Vatikanstadt (Heiliger Stuhl)|Venezuela|Vereinigte Arabische Emirate|Vereinigtes Königreich|Vietnam|Wallis und Futuna|Weihnachtsinsel|Westsahara|Zentralafrikanische Republik|Zimbabwe|Zypern",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Die Bestellung muss mindestens 1 Posten enthalten.",
	"compare-not-equal": "{property} muß sich von {compareSource} unterscheiden.",
	"entry-notification-footer": "Sie haben diese Nachricht erhalten, weil Sie in den Einstellungen von Cognito Forms die \"E-Mail Benachrichtigung bei Übermittlung\" gewählt haben.",
	"save-and-resume-copy-link-label": "Kopieren Sie Ihren Formular Link:",
	"entry-confirmation-footer": "Sie erhalten diese E-Mail Bestätigung, weil Sie Daten zu [Name] übermittelt haben.",
	"required-if-on-or-before": "{property} ist erforderlich wenn {compareSource} am oder vor dem {compareValue} ist.",
	"string-format": "{property} muss im Format {formatDescription} eingegeben werden.",
	"switch-to-drawing-mode": "Wechsel vom Eingabemodus in den Zeichenmodus.",
	"switch-to-typing-mode": "Wechsel vom Zeichenmodus in den Eingabemodus."
};
